import { reduxKey } from './constants';
import { getCurrentModal } from '../../Modals/redux/selectors';
import { ModalType } from '../../Modals/redux/types';
function getStateSlice(state) {
    return state[reduxKey] || {};
}
export function isAwardModalOpen(state) {
    var _getCurrentModal;
    return ((_getCurrentModal = getCurrentModal(state)) === null || _getCurrentModal === void 0 ? void 0 : _getCurrentModal.type) === ModalType.AWARD_BADGE;
}
export function getAwardModalBadges(state, userId) {
    var _getStateSlice_awardableBadges;
    const awardableBadges = (_getStateSlice_awardableBadges = getStateSlice(state).awardableBadges) === null || _getStateSlice_awardableBadges === void 0 ? void 0 : _getStateSlice_awardableBadges[userId];
    if (!awardableBadges) {
        return [];
    }
    return awardableBadges.results;
}
export function getGemRestrictions(state) {
    return getStateSlice(state).gemRestrictions;
}
export function getIsAwarding(state) {
    return getStateSlice(state).isAwarding;
}
export function getErrorMsg(state) {
    return getStateSlice(state).errorMsg;
}

//# sourceMappingURL=selectors.js.map